import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const SortIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 8H4M8 12L4 8L8 4M20 16H4M16 20L20 16L16 12"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

SortIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(SortIcon);
